import { Flex, Text, Box, Accordion, Tooltip } from "@mantine/core";
import { formatBigMonetaryValue } from "../../Funcs";
import { resolveFieldWithFallback } from "./infotab-utils";
import { OverflownText } from "../../../OverflownText";
import React, { useState } from "react";

const MultipleAccountsInfo = ({ item, tab }: { item: any; tab: any }) => {
  const [accountsOpened, setAccountsOpened] = useState(false);

  const formatValue = (property: any, value: string | any) => {
    if (value === undefined || value === null || value === "") {
      value = "N/A";
    } else if (typeof value === "number") {
      value = formatBigMonetaryValue(value, property.prefix);
    } else if (typeof value === "boolean") {
      value = value ? "Yes" : "No";
    }
    return value;
  };

  const renderChildRows = () => (
    <Box>
      {item?.childEvidences
        ?.slice() // clone to avoid mutating original array
        .sort((a: any, b: any) =>
          (a.title || "").localeCompare(b.title || "", undefined, {
            sensitivity: "base", // ignore case
          })
        )
        .map((child: any, idx: number) => (
          <Flex key={child._id || idx} mt={8} mb={8} gap={12}>
            {tab.properties?.map((childProperty: any, childIdx: number) => (
              <Flex align="center" key={childProperty.fieldPath}>
                <Box
                  pl={childIdx === 0 ? "0" : "8px"}
                  mr={12}
                  w="93px"
                  sx={{
                    borderLeft: childIdx === 0 ? "none" : "1px solid #D8D8DB",
                  }}
                >
                  <Tooltip label={childProperty.label || "N/A"}>
                    <Text fz="12px" color="#585C68" lineClamp={1} h={16}>
                      {childProperty.label}
                    </Text>
                  </Tooltip>
                  <OverflownText
                    fw={600}
                    fz="12px"
                    lineClamp={1}
                    color="#212529"
                  >
                    {formatValue(
                      childProperty,
                      resolveFieldWithFallback(child, childProperty.fieldPath)
                    ) || "N/A"}
                  </OverflownText>
                </Box>
              </Flex>
            ))}
          </Flex>
        ))}
    </Box>
  );

  return (
    <Box mt={12}>
      <Flex key={tab.label} direction="column">
        <Flex h={32} align="center">
          <Text fz={12} h={16} w={120}>
            {tab.label}
          </Text>
          <Text fz={12}>{tab.multipleLabel || 'Multiple clients'} ({item?.customersCount})</Text>
          <Accordion
            value={accountsOpened ? "accounts" : undefined}
            onChange={() => setAccountsOpened((v) => !v)}
            chevronPosition="right"
            p={0}
            m={0}
            styles={{
              item: { border: "none" },
              control: {
                padding: 0,
                minWidth: 24,
                minHeight: 24,
                width: 24,
                height: 24,
                justifyContent: "flex-end",
              },
              chevron: { margin: 0 },
            }}
          >
            <Accordion.Item value="accounts">
              <Accordion.Control />
            </Accordion.Item>
          </Accordion>
        </Flex>
        {accountsOpened && renderChildRows()}
      </Flex>
      {tab.label == 'Account' ?
        <Box>
          <Flex key={'arr'} h={32} align="center">
            <Text fz={12} h={16} w={120}>
            ARR
            </Text>
            <Text fz={12}>{formatBigMonetaryValue(item?.aggregations?.accountsTotalArr?.total ?? 'N/A')}</Text>
          </Flex>
          <Flex key={'type'} h={32} align="center">
            <Text fz={12} h={16} w={120}>
            Type
            </Text>
            <Text fz={12}>Multiple</Text>
          </Flex>
          <Flex key={'plan'} h={32} align="center">
            <Text fz={12} h={16} w={120}>
           Plan
            </Text>
            <Text fz={12}>N/A</Text>
          </Flex>
        </Box> :
        null
      }
    </Box>
  );
};

export default MultipleAccountsInfo;
